import { useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { invalidateAllMemberQueries } from "@/react/components/ProfileModalV3/Body/ConnectBanner/util";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useWithdrawConnection } from "@/react/hooks/connections/useWithdrawConnection";
import { Icon } from "../../../Icon";
import { Button } from "../../../uikit/Button";
import { useToast } from "../../../uikit/ToastV2";
import { Typography } from "../../../uikit/Typography";
import { useWithdrawConnectionConfirmModal } from "./WithdrawConnectionConfirmModal";

export const PendingButton = ({
  connectionId,
  recipient,
  memberPublicUid,
  fullWidth = true,
}: {
  connectionId?: string;
  recipient: string;
  memberPublicUid?: string;
  fullWidth?: boolean;
}) => {
  const withdrawConnectionConfirmModal = useWithdrawConnectionConfirmModal();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { mutate: withdrawConnection, isLoading: isWithdrawing } =
    useWithdrawConnection({
      onSuccess: async () => {
        await invalidateAllMemberQueries(queryClient, memberPublicUid ?? "");
        toast.success(
          t("profile_drawer.connect_banner.messages.connection_withdrawn"),
        );
      },
    });

  const handleWithdrawConnection = async (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
    event.stopPropagation();

    await withdrawConnectionConfirmModal.show({
      onConfirm: () => {
        void withdrawConnectionConfirmModal.hide();
        if (connectionId) {
          withdrawConnection(connectionId);
        }
      },
      onCancel: () => {
        void withdrawConnectionConfirmModal.hide();
      },
      disabled: isWithdrawing,
      recipient,
    });
  };

  return (
    <Button
      variant="secondary"
      className={classNames(
        "bg-secondary hover:!bg-tertiary hover:!border-secondary !h-8 !border-transparent !px-4 !font-medium",
        fullWidth ? "w-full" : "",
      )}
      onClick={handleWithdrawConnection}
    >
      <Icon
        type="16-clock"
        size={16}
        useWithFillCurrentColor
        className="mr-2 mt-[-3px]"
      />
      <Typography.LabelSm color="text-primary" weight="font-medium">
        {t("pending")}
      </Typography.LabelSm>
    </Button>
  );
};
